import { render, staticRenderFns } from "./ModelingRuleDialog.vue?vue&type=template&id=1a6d988e&scoped=true&"
import script from "./ModelingRuleDialog.vue?vue&type=script&lang=js&"
export * from "./ModelingRuleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6d988e",
  null
  
)

export default component.exports